import { render } from "./OrderErrorModal.vue?vue&type=template&id=405d754c"
import script from "./OrderErrorModal.vue?vue&type=script&lang=js"
export * from "./OrderErrorModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/check/checkout.trguj.me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__